export default "__VITE_ASSET__ChdiW_7G__"